import { createContext, useContext, useState, useCallback, type ReactNode, createElement } from 'react';
import { type Theme, getTheme, saveTheme, applyTheme } from '@/lib/theme';

interface ThemeContextType {
  theme: Theme;
  toggleTheme: () => void;
}

export const ThemeContext = createContext<ThemeContextType>({
  theme: 'light',
  toggleTheme: () => {},
});

export function ThemeProvider({ children }: { children: ReactNode }) {
  const [theme, setTheme] = useState<Theme>(() => {
    const t = getTheme();
    applyTheme(t);
    return t;
  });

  const toggleTheme = useCallback(() => {
    const next: Theme = theme === 'light' ? 'dark' : 'light';
    setTheme(next);
    saveTheme(next);
    applyTheme(next);
  }, [theme]);

  return createElement(ThemeContext.Provider, { value: { theme, toggleTheme } }, children);
}

export function useTheme(): ThemeContextType {
  return useContext(ThemeContext);
}
